import {
  TrackingPageContext,
  trackContentView,
} from '@aboutyou/legacy-tracking-sdk';
import {useTrackingPageContextCallback} from '../context/PageTrackingContext';
import {useConvertUserAndSessionToCustomer} from '../trackerComponents/TrackCustomer/useConvertUserAndSessionToCustomer';
import {useTracking} from '../utils/utils';

interface Props {
  breadcrumbsPath?: string;
  pageTitle: string;
  overridePageProps?: {type?: string; id?: number};
  isNotFound?: boolean;
}

export const useTrackContentView = () => {
  const getPageContext = useTrackingPageContextCallback();
  const {TrackingClient} = useTracking();
  const customer = useConvertUserAndSessionToCustomer();

  return ({
    pageTitle,
    breadcrumbsPath,
    isNotFound,
    overridePageProps,
  }: Props) => {
    if (customer) {
      const pageContext = getPageContext();

      const pageType = (() => {
        if (overridePageProps) {
          return overridePageProps.type;
        }
        return isNotFound ? '404' : pageContext.type;
      })();

      TrackingClient.track(
        trackContentView({
          page: {
            ...pageContext,
            ...overridePageProps,
            title: pageTitle,
            type: pageType,
          } as unknown as TrackingPageContext,
          breadcrumbsPath,
          customer,
        }),
      );
    }
  };
};
